import request from '@/utils/request'

export function getLogisticsTraceByNo(data) {
  return request({
    url: '/trace/getLogisticsTraceByNo',
    method: 'post',
    data
  })
}
export function getSystemDictDict(data) {
  return request({
    url: '/systemDict/listDict',
    method: 'post',
  })
}


export function getTraceByWaybillId(waybillId) {
  return request({
    url: '/trace/getTraceByWaybillId?waybillId='+waybillId,
    method: 'post'
  })
}

